import { render, staticRenderFns } from "./GenericHtml.vue?vue&type=template&id=6714e324&scoped=true"
import script from "./GenericHtml.vue?vue&type=script&lang=js"
export * from "./GenericHtml.vue?vue&type=script&lang=js"
import style0 from "./GenericHtml.vue?vue&type=style&index=0&id=6714e324&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6714e324",
  null
  
)

export default component.exports